export default __webpack_public_path__ + "static/media/shape-17.7a6d91c9.png";